module.exports = __webpack_public_path__ + "img/it-consulting-white.a1d72dad.png";